import { cn } from "@/lib/utils"

interface RadioGroupProps {
  name: string
  options: string[]
  value: string
  onChange: (value: string) => void
  className?: string
}

const RadioGroup = ({ options, value, onChange, className = '' }: RadioGroupProps) => {
  return (
    <div className={cn("space-y-4", className)}>
      {options.map((option) => {
        const isChecked = value === option

        return (
          <div key={option} className="w-full max-w-md relative z-20">
            <button
              role="radio"
              aria-checked={isChecked}
              onClick={() => onChange(option)}
              className={cn(
                `w-full flex items-center justify-between p-4 rounded-[15px] border border-base-300
                bg-base-100 shadow-sm hover:border-action-300 transition-colors`,
                isChecked
                  ? "before:absolute before:left-0 before:top-[3px] before:bg-action-600 before:rounded-[15px] before:w-full before:h-full before:-z-10"
                  : ""
              )}
            >
              <span
                className={cn(
                  "text-xs text-neutral-600",
                  isChecked ? "text-action-600" : ""
                )}
              >
                {option}
              </span>
              <div
                className={`h-6 w-6 rounded-lg border-2 transition-colors ${
                  isChecked
                    ? "bg-action-500 border-action-500"
                    : "bg-base-100 border-base-300"
                }`}
              />
            </button>
          </div>
        )
      })}
    </div>
  )
}

export default RadioGroup